// English
export default {
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    back: 'Back',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Info',
    submit: 'Submit',
    close: 'Close',
    search: 'Search',
    more: 'More',
    empty: 'No data',
    yuan: 'CNY'
  },

  nav: {
    home: 'Home',
    market: 'Market',
    mall: 'Mall',
    mine: 'Mine',
    account: 'Account'
  },

  login: {
    title: 'Login',
    account: 'Account',
    password: 'Password',
    code: 'Verification Code',
    sendCode: 'Send Code',
    login: 'Login',
    register: 'Register',
    forgetPassword: 'Forgot Password',
    accountRequired: 'Please enter your account',
    passwordRequired: 'Please enter your password',
    codeRequired: 'Please enter the verification code',
    noAccount: 'No account yet?',
    openAccount: 'Open Account Now',
    contactService: 'Please contact customer service for password reset!',
    loginSuccess: 'Login successful!',
    loginFailed: 'Login failed',
    onlineService: 'Online Service',
    forgetPasswordTip: 'Forgot Password',
    username: 'Username'
  },

  index: {
    title: 'Home',
    quickRecharge: 'Quick Recharge',
    rechargeDesc: 'Bank transfer and multiple payment methods',
    market: 'Trading',
    closed: 'Closed',
    welcome: 'Welcome to our platform! Real-time market updates, safe and convenient trading!'
  },

  verified: {
    title: 'Real-name Verification',
    name: 'Name',
    idcard: 'ID Card Number',
    nameError: 'Invalid name',
    nameRequired: 'Please enter your name',
    idcardRequired: 'Please enter your ID card number',
    frontCardRequired: 'Please upload the front of your ID card',
    backCardRequired: 'Please upload the back of your ID card',
    submit: 'Confirm',
    status0: 'Not Verified',
    status1: 'Under Review',
    status2: 'Verified'
  },

  user: {
    profile: 'Profile',
    account: 'Account',
    settings: 'Settings',
    logout: 'Logout',
    balance: 'Balance',
    assets: 'Assets',
    history: 'History',
    myInfo: 'My Information',
    realName: 'Real-name Verification',
    bankCard: 'Bank Card',
    alipay: 'Alipay',
    phone: 'Phone Number',
    email: 'Email',
    name: 'Name'
  },

  trade: {
    title: 'Trading',
    buy: 'Buy',
    sell: 'Sell',
    price: 'Price',
    quantity: 'Quantity',
    total: 'Total',
    confirm: 'Confirm Trade',
    cancel: 'Cancel Trade',
    orderPlaced: 'Order placed',
    orderFailed: 'Order failed',
    insufficientBalance: 'Insufficient balance',
    priceRequired: 'Please enter price',
    quantityRequired: 'Please enter quantity',
    volume: 'Volume',
    highest: 'Highest',
    lowest: 'Lowest',
    open: 'Open',
    position: 'Position',
    kline: 'K-line',
    fluctuation: 'Fluctuation',
    time1m: '1m',
    time5m: '5m',
    time15m: '15m',
    time30m: '30m',
    time1h: '1h',
    time1d: '1d',
    enterInvestAmount: 'Please enter investment amount'
  },

  market: {
    title: 'Market',
    price: 'Price',
    change: 'Change',
    volume: 'Volume',
    high: 'High',
    low: 'Low',
    open: 'Open',
    close: 'Close',
    upTrend: 'Up',
    downTrend: 'Down'
  },

  mall: {
    title: 'Mall',
    goods: 'Goods',
    cart: 'Shopping Cart',
    order: 'Order',
    price: 'Price',
    quantity: 'Quantity',
    buy: 'Buy',
    addCart: 'Add to Cart',
    checkout: 'Checkout',
    myOrders: 'My Orders'
  },

  recharge: {
    title: 'Recharge',
    amount: 'Recharge Amount',
    method: 'Recharge Method',
    bankTransfer: 'Bank Transfer',
    alipay: 'Alipay',
    wechat: 'WeChat',
    rechargeSuccess: 'Recharge successful',
    copied: 'Copied',
    copiedSuccess: 'Copied',
    rechargeFailed: 'Recharge failed',
    amountRequired: 'Please enter recharge amount',
    methodRequired: 'Please select recharge method',
    rechargeRecord: 'Recharge Record'
  },

  cash: {
    title: 'Withdrawal',
    amount: 'Withdrawal Amount',
    method: 'Withdrawal Method',
    bankCard: 'Bank Card',
    alipay: 'Alipay',
    cashSuccess: 'Withdrawal request submitted',
    cashFailed: 'Withdrawal failed',
    amountRequired: 'Please enter withdrawal amount',
    methodRequired: 'Please select withdrawal method',
    cashRecord: 'Withdrawal Record',
    addBankCard: 'Add Bank Card',
    addAlipay: 'Add Alipay'
  },

  message: {
    title: 'Messages',
    noMessage: 'No messages',
    markRead: 'Mark as read',
    delete: 'Delete',
    news: 'News',
    notification: 'Notification',
    system: 'System Message'
  },

  error: {
    networkError: 'Network error',
    serverError: 'Server error',
    notFound: 'Not found',
    unauthorized: 'Unauthorized',
    forbidden: 'Forbidden',
    timeout: 'Request timeout',
    paramError: 'Parameter error',
    dataError: 'Data error',
    requestFailed: 'Request failed',
    networkErrorRetry: 'Network error, please try again later'
  },

  account: {
    title: 'Account',
    totalAssets: 'Total Assets',
    availableBalance: 'Available Balance',
    frozenBalance: 'Frozen Balance',
    tradingAccount: 'Trading Account',
    fundAccount: 'Fund Account',
    accountInfo: 'Account Information',
    accountSecurity: 'Account Security',
    changePassword: 'Change Password',
    oldPassword: 'Old Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    passwordChanged: 'Password changed successfully'
  },

  help: {
    title: 'Help Center',
    faq: 'FAQ',
    tutorial: 'Tutorial',
    contact: 'Contact Us',
    feedback: 'Feedback',
    about: 'About Us',
    howRecharge: 'How to recharge?',
    rechargeAnswer: 'Please contact online customer service for recharge information',
    howWithdraw: 'How to withdraw?',
    withdrawAnswer: 'Click the withdrawal application on the account page and fill in the relevant information',
    forgetPwd: 'What if I forget my password?',
    forgetPwdAnswer: 'Please contact online customer service for password recovery assistance',
    modifyCard: 'How to modify bank card?',
    modifyCardAnswer: 'Please contact online customer service for bank card modification assistance'
  },

  mine: {
    title: 'Mine',
    myInfo: 'My Information',
    realName: 'Real-name Verification',
    bankCard: 'Bank Card',
    alipay: 'Alipay',
    accountSecurity: 'Account Security',
    logout: 'Logout',
    creditScore: 'Credit Score',
    recommendCode: 'Recommend Code',
    level: 'Level',
    copySuccess: 'Copied',
    phone: 'Phone Number',
    name: 'Name',
    notVerified: 'Not Verified',
    verifying: 'Under Review',
    verified: 'Verified',
    news: 'News',
    passwordModify: 'Change Password',
    bindingInfo: 'Binding Info',
    onlineService: 'Online Service',
    tradingRules: 'Trading Rules',
    aboutUs: 'About Us',
    recommendIdCopied: 'Recommend ID Copied',
    notObtained: 'Not obtained'
  },

  rechargeDetail: {
    title: 'Recharge',
    tip: 'Tip: Click the account number and name to copy',
    bankName: 'Bank Name',
    bankBranch: 'Bank Branch',
    accountNumber: 'Account Number',
    accountName: 'Account Name',
    contactService: 'Contact Online Service',
    amount: 'Recharge Amount',
    depositorName: 'Depositor Name',
    transferRemark: 'Transfer Remark',
    submit: 'Recharge',
    copied: 'Copied'
  },

  cashDetail: {
    title: 'Withdrawal',
    availableAmount: 'Available Amount',
    withdrawAmount: 'Withdrawal Amount',
    fee: 'Fee',
    minAmount: 'Minimum Withdrawal Amount',
    password: 'Withdrawal Password',
    bankCard: 'Withdrawal Account',
    submit: 'Confirm Submit',
    hint: 'Hint',
    limit: 'Withdrawal Limit',
    time: 'Withdrawal Time',
    forgetPwd: 'If you forget your withdrawal password, please',
    retrieve: 'Click to retrieve',
    record: 'Withdrawal Record',
    withdrawal: 'Withdrawal',
    pending: 'Pending',
    rejected: 'Rejected',
    completed: 'Completed',
    arrived: 'Arrived',
    refused: 'Refused',
    reviewing: 'Reviewing'
  },

  bankCard: {
    title: 'Bank Card Management',
    addBank: 'Add Bank Card',
    bindAlipay: 'Bind Alipay',
    bindWallet: 'Bind Wallet Address',
    walletAddress: 'Wallet Address',
    walletSection: 'Wallet Address',
    enterWalletAddress: 'Please enter wallet address',
    cardholderName: 'Cardholder Name',
    cardNumber: 'Card Number',
    bankName: 'Bank Name',
    bankBranch: 'Bank Branch',
    submit: 'Confirm Add',
    realName: 'Real Name',
    alipayAccount: 'Alipay Account',
    bindSubmit: 'Confirm Bind',
    alipaySection: 'Alipay Account',
    enterCardholderName: 'Please enter cardholder name',
    enterCardNumber: 'Please enter card number',
    enterBankName: 'Please enter bank name',
    enterRealName: 'Please enter real name',
    enterAlipayAccount: 'Please enter Alipay account',
    contactService: 'Please contact online service to modify bank card'
  },

  password: {
    modifyLogin: 'Modify Login Password',
    modifyPay: 'Modify Payment Password',
    oldPassword: 'Old Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    payPassword: 'Payment Password',
    confirmPayPassword: 'Confirm Payment Password',
    submit: 'Confirm Modify',
    enterOldPwd: 'Please enter old password',
    enterNewPwd: 'Please enter new password',
    enterConfirmPwd: 'Please enter new password again',
    passwordMismatch: 'Passwords do not match'
  },

  bill: {
    title: 'Bill',
    fundChange: 'Fund Change',
    noRecord: 'No records',
    income: 'Income',
    expense: 'Expense'
  },

  news: {
    title: 'News',
    detail: 'News Detail',
    noNews: 'No news',
    tradeRules: 'Trading Rules',
    aboutUs: 'About Us'
  },

  tradeDetail: {
    buyRise: 'Buy Rise',
    buyFall: 'Buy Fall',
    highest: 'Highest',
    lowest: 'Lowest',
    open: 'Open',
    position: 'Position',
    volume: 'Volume',
    kline: 'K-line',
    fluctuation: 'Fluctuation',
    time1m: '1m',
    time5m: '5m',
    time15m: '15m',
    time30m: '30m',
    time1h: '1h',
    timeDay: '1d'
  },

  service: {
    title: 'Online Service',
    contactService: 'Contact Service',
    anyQuestion: 'If you have any questions, please contact online customer service'
  },

  landing: {
    onlineAccount: 'Open Account Online',
    spotGoods: 'Spot Goods',
    contactService: 'Contact Service',
    personalCenter: 'Personal Center',
    characteristicService: 'Characteristic Service',
    characteristicServiceEn: 'CHARACTERISTIC SERVICE'
  },

  accountDetail: {
    title: 'My Account',
    totalAssets: 'Total Assets',
    profitLoss: 'Profit/Loss',
    position: 'Position Amount',
    availableFunds: 'Available Funds',
    refresh: 'Refresh',
    rechargeRecord: 'Recharge Record',
    rechargeApply: 'Recharge Apply',
    withdrawApply: 'Withdrawal Apply',
    currentEntrust: 'Current Entrust',
    historyEntrust: 'History Entrust',
    bill: 'Bill',
    bankCardManage: 'Bank Card Management',
    accountSecurity: 'Account Security'
  },

  historyEntrust: {
    title: 'History Entrust',
    noRecord: 'No records',
    buyRise: 'Buy Rise',
    buyFall: 'Buy Fall'
  },

  settings: {
    accountSecurity: 'Account Security',
    username: 'Username',
    modifyLoginPwd: 'Modify Login Password',
    modifyPayPwd: 'Modify Payment Password'
  }
}
